import image from '../../img/layouts/layout-preview-all-targets.png';

export const preview = {
  image,
  description: 'Video with Panels',
};
